import React, { useState } from "react";
import { Layout } from "antd";
import AdvisorSidebar from "./AdvisorSidebar";
import AdvisorHeader from "./AdvisorHeader";

const AdvisorMainContent = ({ children, noPadding = false }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  return (
    <Layout className="min-h-screen">
      <AdvisorSidebar
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerClose}
      />

      <Layout className="flex-1 ml-0 xl:ml-60 transition-all duration-300">
        <AdvisorHeader onMenuClick={handleDrawerToggle} />

        <div
          className={`overflow-auto flex-1 ${
            noPadding ? "" : "px-2 pt-6 pb-0 md:px-3 lg:px-4"
          }`}
        >
          {children}
        </div>
      </Layout>
    </Layout>
  );
};

export default AdvisorMainContent;
